export type ExerciseCatalogFilters = {
	search: string
	lifecycle: string
	difficulty: string
	equipment: string
	exerciseType: string
	sort: 'id' | 'name' | 'created_at' | 'updated_at' | 'lifecycle'
	direction: 'asc' | 'desc'
	limit: number
}

export const defaultExerciseCatalogFilters: ExerciseCatalogFilters = {
	search: '',
	lifecycle: '',
	difficulty: '',
	equipment: '',
	exerciseType: '',
	sort: 'updated_at',
	direction: 'desc',
	limit: 25,
}

const validSort = new Set<ExerciseCatalogFilters['sort']>(['id', 'name', 'created_at', 'updated_at', 'lifecycle'])

export const parseExerciseCatalogFilters = (search: string): ExerciseCatalogFilters => {
	const params = new URLSearchParams(search)
	const sort = params.get('sort') as ExerciseCatalogFilters['sort'] | null
	const direction = params.get('direction')
	const parsedLimit = Number(params.get('limit'))
	return {
		search: params.get('search') ?? '',
		lifecycle: params.get('lifecycle') ?? '',
		difficulty: params.get('difficulty') ?? '',
		equipment: params.get('equipment') ?? '',
		exerciseType: params.get('exercise_type') ?? '',
		sort: sort && validSort.has(sort) ? sort : defaultExerciseCatalogFilters.sort,
		direction: direction === 'asc' || direction === 'desc' ? direction : defaultExerciseCatalogFilters.direction,
		limit: Number.isInteger(parsedLimit) && parsedLimit >= 10 && parsedLimit <= 100 ? parsedLimit : defaultExerciseCatalogFilters.limit,
	}
}

export const serializeExerciseCatalogFilters = (filters: ExerciseCatalogFilters) => {
	const params = new URLSearchParams()
	if (filters.search.trim()) params.set('search', filters.search.trim())
	if (filters.lifecycle) params.set('lifecycle', filters.lifecycle)
	if (filters.difficulty) params.set('difficulty', filters.difficulty)
	if (filters.equipment) params.set('equipment', filters.equipment)
	if (filters.exerciseType) params.set('exercise_type', filters.exerciseType)
	if (filters.sort !== defaultExerciseCatalogFilters.sort) params.set('sort', filters.sort)
	if (filters.direction !== defaultExerciseCatalogFilters.direction) params.set('direction', filters.direction)
	if (filters.limit !== defaultExerciseCatalogFilters.limit) params.set('limit', String(filters.limit))
	const value = params.toString()
	return value ? `?${value}` : ''
}
